import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=6ffef561&scoped=true"
import script from "./CompanySetting.vue?vue&type=script&lang=js"
export * from "./CompanySetting.vue?vue&type=script&lang=js"
import style0 from "./CompanySetting.vue?vue&type=style&index=0&id=6ffef561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffef561",
  null
  
)

export default component.exports